import { MetaMaskSDK } from "@metamask/sdk";

export const MMSDK = new MetaMaskSDK({
  dappMetadata: {
    name: "PlanetJ",
    url: window.location.href,
    icon: "https://d1pyi77ms1fhr5.cloudfront.net/assets/pngs/logo.png",
  },
  infuraAPIKey: process.env.REACT_APP_INFURA_PROJECT_ID,
  preferDesktop: false,
});

export const metamaskProvider = MMSDK;

export const connectMetaMask = async () => {
  try {
    await MMSDK.terminate(); // Clears any corrupted session
    await MMSDK.connect();
    const accounts = await MMSDK.getProvider().request({
      method: "eth_requestAccounts",
    });
    return accounts.length > 0 ? accounts[0] : null;
  } catch (error) {
    console.error("MetaMask connection failed:", error);
    // throw error;
  }
};

export const disconnectMetaMask = async () => {
  try {
    await MMSDK.terminate();
  } catch (error) {
    console.error("Error disconnecting MetaMask:", error);
  }
};
